import script from "./LeftMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./LeftMenu.vue?vue&type=script&setup=true&lang=js"

import "./LeftMenu.vue?vue&type=style&index=0&id=f189ac04&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f189ac04"]])

export default __exports__